export const validateFormData = (formData, t) => {
  let errors = {};

  if (formData.ssn && formData.ssn.length !== 14) errors.ssn = t('errors.ssn');
  if (!formData.firstName) errors.firstName = t('errors.firstName');
  if (!formData.lastName) errors.lastName = t('errors.lastName');
  if (!formData.society) errors.society = t('errors.society');
  if (!formData.email) {
    errors.email = t('errors.required');
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    errors.email = t('errors.invalidEmail'); // À traduire dans ton fichier i18n
  }
  if (!formData.file) errors.file = t('errors.file');
  if (!formData.additionalFile) errors.additionalFile = t('errors.additionalFile');
  if (!formData.additionalFile2) errors.additionalFile2 = t('errors.additionalFile2');

  return errors;
};

export const validateCustomerAndBillingFormData = (customer, billing, t) => {
  const errors = {};

  // Champs Customer
  if (!customer.email) {
    errors.email = t('errors.email');
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(customer.email)) {
    errors.email = t('errors.invalidEmail');
  }

  if (!customer.lastname) errors.lastname = t('errors.lastName');
  if (!customer.firstname) errors.firstname = t('errors.firstName');
  if (!customer.phone) errors.phone = t('errors.phone');

  // Champs Billing
  if (!billing.address) errors.address = t('errors.address');
  if (!billing.city) errors.city = t('errors.city');
  if (!billing.postalCode) errors.postalCode = t('errors.postalCode');
  if (!billing.country) errors.country = t('errors.country');

  return errors;
};

export const validateAddressFormData = (formData, t) => {
  let errors = {};

  if (!formData.address) errors.address = t('errors.address');
  if (!formData.zipCode) errors.zipCode = t('errors.zipCode');
  if (!formData.town) errors.town = t('errors.town');
  if (!formData.dateOfBirth) errors.dateOfBirth = t('errors.dateOfBirth');
  if (!formData.placeOfBirth) errors.placeOfBirth = t('errors.placeOfBirth');

  return errors;
};